const _ = require("lodash")

function getJsonChanges(previousObj, currentObj, path = "") {
  const result = {}

  if (_.isEqual(previousObj, currentObj)) {
    return result
  }

  const allKeys = Object.keys(currentObj)

  allKeys.forEach((key) => {
    const prevVal = previousObj[key]
    const currVal = currentObj[key]
    const currentPath = path ? `${path}.${key}` : key

    if (!_.isEqual(prevVal, currVal)) {
      // Property exists in both but differs
      if (_.isObject(prevVal) && _.isObject(currVal)) {
        // Recurse for nested objects
        const nestedChanges = getJsonChanges(prevVal, currVal, currentPath)
        if (Object.keys(nestedChanges).length > 0) {
          result[currentPath] = nestedChanges
        }
      } else {
        result[key] = currVal
      }
    }
  })

  return result
}

module.exports = {
  getJsonChanges,
}
